import React from 'react';

import Tag from 'antd/es/tag';

const IndividualStatusTag = ({ isWorking }) => (
  <Tag color={isWorking ? 'success' : undefined}>
    {isWorking ? 'Working' : 'Off'}
  </Tag>
);

export default IndividualStatusTag;
